import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class UsersService {

    baseApiUrl = 'http://gdpr.ende.gr/api';

    constructor(private http: HttpClient) { }

    getUsers(): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', '123456');
        headers = headers.append('Content-Type', 'application/json');

        return this.http.get<any>(
            `${this.baseApiUrl}/users`,
            { headers }
        )
    }

    submitUser(user): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', '123456');

        return this.http.post<any>(
            `${this.baseApiUrl}/user-submit.php`,
            user,
            { headers }
        )
    }
}
